import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {ThemeColourGroups} from '../../theme';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

const iconBgVariants = {
  slate: 'bg-slate3',
  blue: 'bg-blue3',
  tomato: 'bg-tomato3',
  grass: 'bg-grass3',
  amber: 'bg-amber3',
};
const iconColourVariants = {
  slate: 'text-slate9',
  blue: 'text-blue9',
  tomato: 'text-tomato9',
  grass: 'text-grass9',
  amber: 'text-amber9',
};

type Props = {
  icon: IconDefinition;
  colour?: ThemeColourGroups;
};
export function DialogIcon({icon, colour = 'blue'}: Props) {
  return (
    <div
      aria-hidden="true"
      className={clsx(
        'mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full sm:h-10 sm:w-10',
        iconBgVariants[colour]
      )}
    >
      <Icon
        icon={icon}
        className={clsx('h-6 w-6', iconColourVariants[colour])}
      />
    </div>
  );
}

DialogIcon.displayName = 'DialogIcon';
